import { apiFetch, apiFetchBlob } from "./api";

export interface DailyReconException {
  category: string;
  reference: string;
  expectedAmount: number;
  actualAmount: number;
  difference: number;
  detail: string;
}

export interface DailyReconRun {
  runId: number | null;
  isPreview: boolean;
  accountingDate: string;
  runAtUtc: string | null;
  runByName: string | null;
  status: string;
  exceptionCount: number;
  invoicesEligibleIncGst: number;
  invoicesExportedIncGst: number;
  invoicesPendingIncGst: number;
  invoicesEligibleCount: number;
  invoicesPendingCount: number;
  paymentsEligibleTotal: number;
  paymentsExportedTotal: number;
  paymentsPendingTotal: number;
  paymentsEligibleCount: number;
  paymentsPendingCount: number;
  fullyExported: boolean;
  eodInvoicesTodayTotal: number;
  eodTotalsPresent: boolean;
  accountsCheckedCount: number;
  accountsOutOfBalanceCount: number;
  exceptions: DailyReconException[];
  pdfFileName: string | null;
}

export interface DailyReconListItem {
  runId: number;
  accountingDate: string;
  runAtUtc: string;
  runByName: string;
  status: string;
  exceptionCount: number;
}

export const dailyReconApi = {
  today: () => apiFetch<DailyReconRun>("/api/reports/daily-recon/today"),
  run: () => apiFetch<DailyReconRun>("/api/reports/daily-recon/run", { method: "POST" }),
  history: (take = 50) => apiFetch<DailyReconListItem[]>(`/api/reports/daily-recon?take=${take}`),
  detail: (id: number) => apiFetch<DailyReconRun>(`/api/reports/daily-recon/${id}`),
  downloadPdf: async (id: number, fileName: string) => {
    const blob = await apiFetchBlob(`/api/reports/daily-recon/${id}/pdf`);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.rel = "noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Revoke after 60s — the browser needs the URL alive long enough to
    // process the click; immediate revocation can race in some browsers.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },
};
